(function () {
  var root = document.getElementById('qx26');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  // タップで別アングルに切り替え（スマホ用）
  root.addEventListener('click', function (e) {
    var m = e.target.closest('[data-qx-swap]');
    if (m) m.classList.toggle('is-alt');
  });

  // ---- 出現アニメーション ----
  var targets = root.querySelectorAll('.qx-rv, .qx-item');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -15% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('is-in'); });
  }

  // セクションが画面内にある間だけ雪を表示
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      root.classList.toggle('is-inview', en[0].isIntersecting);
    }).observe(root);
  }

  // ---- スクロール連動（HERO・パララックス・タイムライン） ----
  var hero = root.querySelector('[data-qx-hero]');
  var tl = root.querySelector('[data-qx-tl]');
  var tlItems = tl ? tl.querySelectorAll('.qx-tl__item') : [];
  var frames = root.querySelectorAll('.qx-item__frame');
  var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    if (hero) {
      var r = hero.getBoundingClientRect();
      var p = clamp(-r.top / (r.height - vh));
      hero.style.setProperty('--p', p.toFixed(4));
      hero.style.setProperty('--e', ease(clamp(p / .8)).toFixed(4));
    }
    frames.forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh; // -1〜1
      f.style.setProperty('--py', (c * -40).toFixed(1) + 'px');
    });
    if (tl) {
      var tr = tl.getBoundingClientRect();
      var t = clamp((vh * .8 - tr.top) / (tr.height + vh * .3));
      tl.style.setProperty('--tl', t.toFixed(3));
      tlItems.forEach(function (li, i) { li.classList.toggle('is-on', t >= i / (tlItems.length - 1) - .02); });
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  if (!reduce) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // ---- 受付開始までの日数 ----
  var countEl = root.querySelector('[data-qx-count]');
  var count = countEl && countEl.querySelector('b');
  if (count) {
    var start = new Date(countEl.getAttribute('data-start') || '2026-11-01T00:00:00+09:00').getTime();
    var days = Math.ceil((start - Date.now()) / 86400000);
    if (days > 0) count.textContent = days; else count.parentNode.textContent = 'ご予約受付中';
  }

  // ---- 雪 ----
  var cv = root.querySelector('.qx-snow');
  if (cv && !reduce) {
    var ctx = cv.getContext('2d'), flakes = [], W, H, dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() {
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(90, W / 14));
      flakes = [];
      for (var i = 0; i < n; i++) flakes.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.8 + .6, s: Math.random() * .5 + .25, d: Math.random() * Math.PI * 2 });
    }
    size(); window.addEventListener('resize', size);
    (function loop() {
      if (root.classList.contains('is-inview')) {
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = 'rgba(255,255,255,.75)';
        flakes.forEach(function (f) {
          f.y += f.s; f.d += .01; f.x += Math.sin(f.d) * .35;
          if (f.y > H + 4) { f.y = -4; f.x = Math.random() * W; }
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2); ctx.fill();
        });
      }
      requestAnimationFrame(loop);
    })();
  }
})();
